export function htmlToText(html: string): string {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const textContent =
        doc.body?.innerText ?? doc.documentElement.innerText ?? ''

    return textContent.replace(/\s{2,}/g, ' ')
}
